import React, { FunctionComponent } from "react";
import { MenuItem, MenuItems } from "../../../../components/@types";
import YaraSelectInput from "./YaraSelectInput";

interface IYaraStringMatchVariableFilterProps {
  items?: MenuItems;
  active?: MenuItem;
  disabled?: boolean;
  onChange: (value: MenuItem) => void;
}

const YaraStringMatchVariableFilter: FunctionComponent<
  IYaraStringMatchVariableFilterProps
> = ({ items, active, disabled, onChange }) => (
  <YaraSelectInput
    label={"Variable"}
    placeholder={"Select String"}
    allLabel={"All Strings"}
    items={items}
    active={active}
    disabled={disabled}
    onChange={onChange}
  />
);

export default YaraStringMatchVariableFilter;
